import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import Charts from './Charts';
import ResultSummary from './ResultSummary';
import lodash from 'lodash'
import './ChartView.css';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const ChartView = (payload) => {
    const { strategyData = {}, listing = {}, metaData = {} } = payload;

    const handleExportPdf = () => {
        const printClass = 'chartview-print-mode';
        const { body } = document;
        const previousAfterPrint = window.onafterprint;

        const cleanup = () => {
            body.classList.remove(printClass);
            window.onafterprint = previousAfterPrint;
        };

        window.onafterprint = () => {
            cleanup();
            if (typeof previousAfterPrint === 'function') {
                previousAfterPrint();
            }
        };

        body.classList.add(printClass);
        setTimeout(() => {
            window.print();
        }, 100);
    };

    return !lodash.isEmpty(strategyData) ?
        <>
            {/*
            <div className="d-flex justify-content-end mt-3 chartview-export-btn">
                <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={handleExportPdf}
                >
                    Export ChartView as PDF
                </button>
            </div>
            */}
            <div className="chartview-print-area">
                <section className="summary mt-4">
                    <ResultSummary data={metaData} />
                </section>
                <section className="charts mt-4">
                    <Charts data={metaData} />
                </section>
            </div>
        </> : '';

};

export default ChartView;
